// Third party library imports
import { inject } from "@angular/core";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { lastValueFrom } from "rxjs";

// Zopup library imports
import { BizError, CountryDto, CountryListQuery } from "@zopup/zop-types";
import { X_APP_ID } from "@zopup/zop-shared";

// Internal project imports
import { CountryService } from "./country.service";

type CountryState = {
    countries: CountryDto[];
    selectedCountry: CountryDto;
    isLoading: boolean;
    errors: BizError[];
    filter: CountryListQuery;
};

const initialState: CountryState = {
    countries: [],
    selectedCountry: {},
    isLoading: false,
    errors: [],
    filter: { searchText: ''},
};

export const CountryStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store, countryService = inject(CountryService)) => ({
        onSelectCountry(country: CountryDto): void {
            patchState(store, { selectedCountry: country });
        },
        updateQuery(query: CountryListQuery): void {
            patchState(store, {
                filter: query,
            });
        },
        getList: async () => {
            try{
                patchState(store, { isLoading: true });
                const countries = await lastValueFrom(countryService.countryListGet(X_APP_ID));
                if (countries.isSuccess) {
                    patchState(store, {
                        countries: countries.result,
                        isLoading: false,
                    });
                } else {
                    patchState(store, {
                        countries: countries.result,
                        errors: countries.errors,
                        isLoading: false,
                    });
                }
            }
            catch(error){
                console.log('CountryStore.getList: ' + error);
            }
        },
    }))
);